
import React, { useEffect, useState } from "react";
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import Modal from 'react-modal';


const MicroModuleListing = () => {
  const [microModuleDetails, setMicroModuleDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const orgInfo = JSON.parse(localStorage.getItem("orgInfo"));

  useEffect(() => {
    fetchMicroModuleListing();
  }, []);

  const fetchMicroModuleListing = () => {
    if (!orgInfo?.org_id) return;
    setLoader(true);
    const token = apiService.getAuthToken();
    apiService
      .get(`get-ic-user-micro-course-completed-list/${orgInfo?.org_id}`, token)
      .then(
        (response) => {
          setMicroModuleDetails(response?.data);
          setLoader(false);
        },
        (error) => {
          console.error("Error fetching data", error);
          setLoader(false);
        }
      );
  };

  const openVideoModal = () => {
    setModalOpen(true);
  };

  const closeVideoModal = () => {
    setModalOpen(false);
  };

  return (

    <>
      <h5 className="mb-1 fw-bold">
        Micro-Modules <small className="text-muted">(Optional)</small> <img src="/images/i_icon.svg" onClick={openVideoModal} alt='add icon' style={{ width: "30px", height: "32px", cursor: "pointer", filter: "invert(1) brightness(0.5)" }} />
      </h5>
      <div className="card my-4 p-4 border-radius-20 bg-white shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1 fw-bold">
              All Micro Modules
            </h5>
            <p className="mb-0 text-muted">
              Quarterly auto-assigned training modules for your IC members
            </p>
          </div>
          {microModuleDetails?.microCourseList?.length > 0 && (
          <a href="/micro-modules-stats" className="btn btn-secondary px-5">
            <img src="/images/bar-chart.svg" alt="Modules" className="me-2"></img> View Stats
          </a> )}
        </div>

        <div className="row border-top mt-2 pt-4">
          {microModuleDetails?.microCourseList?.length > 0 ? (<>
            {microModuleDetails?.microCourseList?.map((module, index) => {
              const completed = module?.totalCourseCompletedUser || 0;
              const total = module?.totalOrgICUser || 1;
              const percent = Math.round((completed / total) * 100);
              const formattedDate = new Date(module?.published_date).toLocaleString('default', { month: 'short', year: 'numeric' });

              // Cycle through 4 Bootstrap theme colors
              const colors = ["danger", "info", "warning", "success"];
              const color = colors[index % colors.length]; // rotate colors
              const bgClass = `bg-${color}-subtle`;

              return (
                <div className="col-md-3 mt-3" key={index}>
                  <div className={`card h-100 shadow-sm ${bgClass} border-0`}>
                    <div className="card-body p-4">
                      <div className="mb-2">
                        <span className={`badge text-white bg-${color}`}>
                          <img src="/images/calender-icon.svg" alt="Calendar" width={12} style={{ filter: 'invert(1) brightness(2)' }} /> {formattedDate}
                        </span>
                      </div>
                      <h6 className="card-title fw-semibold">{module.name}</h6>

                      <div className="progress mt-3" style={{ height: "4px" }}>
                        <div
                          className={`progress-bar bg-${color}`}
                          role="progressbar"
                          style={{ width: `${percent}%` }}
                          aria-valuenow={percent}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>

                      <div className="small text-end text-black mt-2">
                        {completed}/{total} completed
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}  </>
          ) : (
            <div className="col-12 text-center mt-2">
              <div className="text-muted">No Micro Modules are published.</div>
            </div>
          )}

          <Modal
            isOpen={isModalOpen}
            onRequestClose={closeVideoModal}
            contentLabel="Video Modal"
            className='videoModal bg-white w-25 p-4'
          > <button type="button" className="close text-white" onClick={closeVideoModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
            <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
          </svg></button>
            <div className='d-flex justify-content-start align-items-center border-bottom text-left pb-2'>
              <h2 className='font-20 fw-bold text-left mb-2'>Micro-Modules (Optional)</h2>
            </div>
            <div className='modal-body py-4'>
              <p className='small'>Every quarter, micro-modules are automatically assigned to IC members to strengthen their capabilities in the role. As an admin, you can view all active modules for your organisation and easily track completion progress for each IC member.</p>
            </div>
            <div className="text-center border-top pt-2">
              <button className='btn btn-primary py-1 px-4 mt-2 mx-auto' onClick={closeVideoModal}>Ok</button>
            </div>
          </Modal>
        </div>

        {/* <div className="d-flex justify-content-between border-top pt-2 mt-2 text-muted small">
          <div>Total Modules: {microModuleDetails?.microCourseList?.length}</div>
          <div>
            Next Quarter Assignment: <strong>July 2025</strong>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default MicroModuleListing;


